import React, {FC, useContext} from 'react';
import {PortalContext} from 'modules/portal/context/PortalContext';
import classNames from 'classnames';
import style from './style.module.scss';

export const ModalOverlay: FC<React.HTMLAttributes<HTMLDivElement>> = (props) => {
    const {visibility} = useContext(PortalContext);

    return <div {...props} className={classNames(style.modalOverlay, {[style.modalOverlayVisible]: visibility})} />;
};
